import { useTheme } from "@mui/material";
import { Users } from "lucide-react";
import { type FC, useState } from "react";
import { AdvisorCard } from "web_myplann/Advisor/Components/AdvisorCard";
import { AdvisorPickerDrawer } from "web_myplann/Advisor/Components/AdvisorPickerDrawer";
import { useAdvisorDetailQuery } from "web_myplann/Api/Advisor/useAdvisorDetailQuery";
import { useAdvisorsQuery } from "web_myplann/Api/Advisor/useAdvisorsQuery";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MissingAdvisor } from "web_myplann/Profile/Components/MissingAdvisor";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

const R = Resources.Advisor;

export const AdvisorPage: FC = () => {
	const theme = useTheme();
	const { t } = useResource();

	const [selectedId, setSelectedId] = useState<string>();
	const [pickerOpen, setPickerOpen] = useState(false);

	const { data: advisors = [], isLoading: listLoading } = useAdvisorsQuery();

	const mainAdvisor =
		advisors.find((advisor) => advisor.is_main) ?? advisors[0];
	const selected =
		advisors.find((advisor) => advisor.id === selectedId) ?? mainAdvisor;
	const hasMultiple = advisors.length > 1;

	const { data: detail, isLoading: detailLoading } = useAdvisorDetailQuery(
		selected?.id,
	);

	const isLoading = listLoading || (Boolean(selected?.id) && detailLoading);

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.grey[50]}
			topBar={
				<NavigationHeader
					title={t(R.title)}
					bgColor={theme.palette.background.appBar}
					defaultRoute={Routing.Dashboard.path()}
					endComponent={
						hasMultiple ? (
							<Users
								size={theme.iconSize.md}
								cursor="pointer"
								color={theme.palette.grey[700]}
								onClick={() => setPickerOpen(true)}
							/>
						) : undefined
					}
				/>
			}
		>
			{isLoading ? (
				<MyPlannLoading />
			) : !selected || !detail?.name ? (
				<MissingAdvisor />
			) : (
				<>
					<AdvisorCard
						id={detail.id}
						name={detail.name}
						job={detail.job ?? undefined}
						phone={detail.phone ?? undefined}
						email={detail.email}
						address={detail.address ?? undefined}
						photo={detail.photo_avatar ?? undefined}
						conversationId={detail.conversation_id ?? undefined}
						showMainBadge={hasMultiple && Boolean(detail.is_main)}
					/>

					<AdvisorPickerDrawer
						open={pickerOpen}
						onClose={() => setPickerOpen(false)}
						advisors={advisors}
						selectedId={selected.id}
						onSelect={(id) => {
							setSelectedId(id);
							setPickerOpen(false);
						}}
					/>
				</>
			)}
		</MyPlannLayout>
	);
};
